// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-preview[data-v-adff4eae]{height:800px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
